import React from 'react';

import { useBackofficeSidebarSections } from '@/backoffice/features/backoffice-sidebar/hooks/use-backoffice-sidebar-sections/use-backoffice-sidebar-sections';
import { Sidebar } from '@/shared/features/sidebar/sidebar';

export const BackofficeSidebar = () => {
  const sections = useBackofficeSidebarSections();

  return <Sidebar sections={sections} />;
};
